import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Scorrimento orizzontale con rotellina del mouse + frecce laterali.
// Le frecce compaiono solo quando il contenuto eccede la larghezza visibile;
// ai bordi la rotellina torna a scorrere la pagina normalmente.
export function HSlider({ children, testid, className = "" }) {
  const ref = useRef(null);
  const [canL, setCanL] = useState(false);
  const [canR, setCanR] = useState(false);

  const update = () => {
    const el = ref.current;
    if (!el) return;
    setCanL(el.scrollLeft > 4);
    setCanR(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onWheel = (e) => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      const atStart = el.scrollLeft <= 0 && e.deltaY < 0;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1 && e.deltaY > 0;
      if (atStart || atEnd) return;
      el.scrollLeft += e.deltaY;
      e.preventDefault();
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("resize", update);
    update();
    const t = setTimeout(update, 400);
    return () => {
      el.removeEventListener("wheel", onWheel);
      window.removeEventListener("resize", update);
      clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);

  const scroll = (dir) => {
    const el = ref.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  const arrowCls =
    "absolute top-1/2 -translate-y-1/2 z-10 chamfer-sm border border-[#2A2A2A] bg-[#050505]/90 hover:border-wardogs text-steel hover:text-wardogs p-2.5 transition-colors duration-300";

  return (
    <div className={`relative ${className}`} data-testid={testid}>
      <div ref={ref} onScroll={update} data-lenis-prevent className="scrollbar-none flex gap-6 overflow-x-auto snap-x">
        {children}
      </div>
      {canL && (
        <button onClick={() => scroll(-1)} className={`${arrowCls} -left-3`} data-testid={`${testid}-prev`} aria-label="Scorri a sinistra">
          <ChevronLeft className="w-5 h-5" />
        </button>
      )}
      {canR && (
        <button onClick={() => scroll(1)} className={`${arrowCls} -right-3`} data-testid={`${testid}-next`} aria-label="Scorri a destra">
          <ChevronRight className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
